import { render } from "./TextLinksRenderer.vue?vue&type=template&id=4a5a627c&scoped=true"
const script = {}

import "./TextLinksRenderer.vue?vue&type=style&index=0&id=4a5a627c&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a5a627c"]])

export default __exports__